
export default {
    setList(state, params) {
        let list = state.list.find(image => image.optionId == params.optionId);
        if (list) {
            list.data = params.list
        } else {
            state.list.push({ optionId: params.optionId, data: params.list });
        }
    }
}
